import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";

export const login = async (email: string, password: string) => {
  var request: RestApiRequest = {
    url: "/api/auth/login",
    method: "POST",
    body: { email: email, password: password },
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };
  const response = await fetchData(request);
  return response;
};

export const logout = async () => {
  var request: RestApiRequest = {
    url: "/api/auth/logout",
    method: "POST",
  };
  const response = await fetchData(request);
  return response;
};
